import { getters } from "@/constants/state";

export default {
  [getters.HOLIDAYS_APPROVED_GETTER]: (state) => state.approvedHolidays,
  [getters.HOLIDAYS_UNAPPROVED_GETTER]: (state) => state.unapprovedHolidays,
  [getters.HOLIDAYS_CONFIRMED_GETTER]: (state) => state.confirmedHolidays,
  [getters.HOLIDAYS_USER_HOLIDAYS_GETTER]: (state) => state.userHolidays,
};
